export enum AuditAction {
  Viewed = 'viewed',
  Edited = 'edited',
  Created = 'created',
  Deleted = 'deleted',
  Invited = 'invited',
  Completed = 'completed',
  Uncompleted = 'uncompleted',
  LoggedIn = 'logged_in',
  Uploaded = 'uploaded',
  Messaged = 'messaged',
}

export enum AuditResourceType {
  Property = 'property',
  Document = 'document',
  Task = 'task',
  User = 'user',
  Score = 'score',
  Report = 'report',
  Message = 'message',
  RFQ = 'rfq',
}

export interface AuditLog {
  id: string;
  propertyId: string;
  userId: string;
  userName: string;
  action: AuditAction;
  resourceType: AuditResourceType;
  resourceId?: string;
  resourceName?: string;
  details?: string;
  timestamp: number;
  createdAt: number;
}

export interface ActivityListResponse {
  items: AuditLog[];
  nextCursor?: string;
}
